import { createApp } from 'vue'
import { createBootstrap } from 'bootstrap-vue-next'
import { createPinia } from 'pinia'
import router from '../vue/routes/startpage-routes'
import StartpageApp from '../vue/startpage/startpage-app.vue'

import '../styles/application.scss'

const element = document.getElementById('levumi')

const init = async () => {
  const data = JSON.parse(element.getAttribute('data')) || {}

  const pinia = createPinia()

  const app = createApp(StartpageApp, data)

  app.use(router)
  app.use(pinia)
  app.use(createBootstrap())

  app.mount('#levumi')
}

if (element) {
  init()
}
